import { FuelDivider, FuelSkeleton } from '@frete.com/fuel-react';
import { FuelFlex, FuelSpacer } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import React, { FC } from 'react';
import { SkeletonList } from '../SkeletonList';

export const SkeletonSideBar: FC<{ isMobile: boolean }> = ({ isMobile }) => (
  <FuelFlex
    defaultProps={{
      flexDirection: 'column',
      customPadding: isMobile ? dsTheme.spacing.km6 : `${dsTheme.spacing.km12} 0 0`,
    }}
    testId="skeleton-sidebar"
  >
    <FuelSkeleton size="custom" shape="square" width="98%" height="80px" />
    <FuelSpacer orientation="vertical" y="km10" />
    <FuelFlex defaultProps={{ gap: 'km2', width: '98%' }}>
      <FuelSkeleton size="custom" shape="square" width="80%" height="40px" />
      <FuelSkeleton size="custom" shape="square" width="20%" height="40px" />
    </FuelFlex>
    <FuelSpacer orientation="vertical" y="km6" />
    <FuelSkeleton size="custom" shape="square" width="25%" height="14px" />
    <FuelSpacer orientation="vertical" y="km3" />
    <FuelDivider size="default" />
    <FuelSpacer orientation="vertical" y="km6" />
    <SkeletonList />
  </FuelFlex>
);
